import { KeyboardEvent } from "react";
import { SearchInputForm } from "src/components/common/form/search/SearchInputForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { useMST3010_R01Store } from "./Store_MST3010_R01";

// Props 타입 정의
interface Props {
  onEnterKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
  yesnoOptions: SysCodeDto[];
}

// 작업장 검색 영역 컴포넌트
export const SearchSection_MST3010_R01 = ({ onEnterKeyDown, yesnoOptions }: Props) => {

	const { MST3010_R01Filter, setMST3010_R01Filter } = useMST3010_R01Store();

	return (
		<SearchSectionForm>
			<div className="h-[80%] flex items-center gap-[12px]">
				{/* 공정명 입력란 */}
				<SearchInputForm
					label="공정명"
					value={MST3010_R01Filter.workplaceNm}
					onChange={(e) => setMST3010_R01Filter({ workplaceNm: e.target.value })}
					onKeyDown={(e) => {
						if (e.key === 'Enter') {
							onEnterKeyDown(e);
						}
					}}
					initValue={() => setMST3010_R01Filter({ workplaceNm: '' })}
				/>
			</div>
		</SearchSectionForm>
	)
} 